import React, { useState } from 'react';
import { Box, Button, Tooltip, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {
  NEXT_BUTTON_TEXT,
  PREVIOUS_BUTTON_TEXT,
  SELECT_MONTH,
} from '../../../constants';
import dayjs from 'dayjs';

const MonthToolbar = ({ label, onNavigate }) => {
  const [isForcePickerOpen, setIsForcePickerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  const currentMonth = dayjs();
  const selectedMonth = dayjs(label);

  const handleNavigate = (action) => {
    onNavigate(action);
  };

  const handleDateChange = (date) => {
    onNavigate('DATE', date);
  };

  const handleClick = (event) => {
    setIsForcePickerOpen(!isForcePickerOpen);
    setAnchorEl(event?.currentTarget);
  };

  return (
    <Box className="posr">
      <Box className="rbc-btn-group">
        <Tooltip
          title={
            <Typography sx={{ fontSize: '0.8rem' }}>
              {PREVIOUS_BUTTON_TEXT}
            </Typography>
          }
          placement="right"
        >
          <Button
            size="small"
            type="button"
            className="prevp-btn"
            onClick={() => handleNavigate('PREV')}
          >
            <ArrowBackIosIcon fontSize="small" />
          </Button>
        </Tooltip>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            views={['month', 'year']}
            value={label}
            open={isForcePickerOpen}
            maxDate={currentMonth}
            onClose={() => setIsForcePickerOpen(false)}
            onChange={handleDateChange}
            PopperProps={{
              placement: 'bottom',
              anchorEl: anchorEl,
            }}
            renderInput={({ disabled, onChange, value }) => (
              <Box className="rbc-btn-group">
                <input
                  style={{ display: 'none' }}
                  value={value}
                  onChange={onChange}
                  disabled={disabled}
                />
                <Tooltip
                  title={
                    <Typography sx={{ fontSize: '0.8rem' }}>
                      {SELECT_MONTH}
                    </Typography>
                  }
                  placement="top"
                >
                  <Button
                    type="button"
                    className="defaultbtn css-input"
                    onClick={handleClick}
                  >
                    <Typography>{label}</Typography>
                  </Button>
                </Tooltip>
              </Box>
            )}
          />
        </LocalizationProvider>

        <Tooltip
          title={
            <Typography sx={{ fontSize: '0.8rem' }}>
              {NEXT_BUTTON_TEXT}
            </Typography>
          }
          placement="left"
        >
          <Button
            type="button"
            className="nextp-btn"
            onClick={() => handleNavigate('NEXT')}
            disabled={selectedMonth.isSame(currentMonth, 'month')}
          >
            <ArrowForwardIosIcon fontSize="small" />
          </Button>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default MonthToolbar;
